import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
import { plainToInstance } from "class-transformer";
import { StudySectionImageDto, } from "healthex-common/study.dtos";
import { generateURL } from "./BaseApiService";
export class StudySectionImageService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getStudySectionImageUploadUrl(orgId, studyId, imageId, sectionType, sectionName, file, additionalSectionId) {
        const localFileInfo = { filename: file.name };
        const response = await axios.put(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/section-images/:imageId/:sectionType/:sectionName/upload-url`, { orgId, studyId, imageId, sectionType, sectionName }), { localFileInfo, additionalSectionId }, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async createStudySectionImage(orgId, studyId, input) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/section-images`, { orgId, studyId }), input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(StudySectionImageDto, response.data);
    }
    async createStudySectionImageBatch(orgId, studyId, input) {
        await axios.post(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/create-section-images-batch`, {
            orgId,
            studyId,
        }), input, authenticatedApiConfig(this.authenticationProvider));
    }
    async updateStudySectionImage(imageId, studyId, orgId, input) {
        const response = await axios.put(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/section-images/:imageId`, {
            orgId,
            studyId,
            imageId,
        }), input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(StudySectionImageDto, response.data);
    }
    async updateStudySectionImageBatch(orgId, studyId, input) {
        await axios.put(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/update-section-images-batch`, {
            orgId,
            studyId,
        }), input, authenticatedApiConfig(this.authenticationProvider));
    }
    async deleteStudySectionImage(orgId, studyId, imageId) {
        await axios.delete(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/sections/images/:imageId`, {
            orgId,
            studyId,
            imageId,
        }), authenticatedApiConfig(this.authenticationProvider));
    }
    async deleteAllSectionImages(orgId, studyId, sectionType, sectionName, additionalSectionId) {
        const baseUrl = generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/sections/:sectionType/:sectionName/images`, { orgId, studyId, sectionType, sectionName });
        const url = additionalSectionId ? `${baseUrl}?additionalSectionId=${additionalSectionId}` : baseUrl;
        await axios.delete(url, authenticatedApiConfig(this.authenticationProvider));
    }
    async moveSectionImage(imageId, studyId, orgId, input) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/section-images/:imageId/move`, {
            orgId,
            studyId,
            imageId,
        }), input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(StudySectionImageDto, response.data);
    }
    async copySectionImage(id, studyId, orgId, input) {
        return await axios.post(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/studies/:studyId/draft/section-images/:id/copy`, {
            orgId,
            studyId,
            id,
        }), input, authenticatedApiConfig(this.authenticationProvider));
    }
}
